import React from "react";
import NavBar from "../Components/NavBar";
import { Link } from "react-router-dom";
const NotFound404 = () => {
  return (
    <div>
      <NavBar />
      <div
        style={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: 20,
        }}
      >
        <h1 style={{ fontSize: 48, fontWeight: 700, marginBottom: 10 }}>404</h1>
        <h3 style={{ marginBottom: 20 }}>Page Not Found</h3>
        <p className="text-muted" style={{ maxWidth: 300, marginBottom: 30 }}>
          The page you are looking for doesn’t exist or has been moved.
        </p>

        <Link
          to="/"
          style={{
            padding: "10px 20px",
            background: "#007bff",
            color: "white",
            borderRadius: 6,
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound404;
